var e={andUp:"& Up",getLabel:function(e){return"Rating: ".concat(e,"/5")},scrollToReviewsSection:"Scroll to reviews section"};export{e as ratingsTranslations};
